import React from 'react';
import Header from '../../website/component/Header';

const PublicRoute = ({ element: Component }) => {    
    return <div>
        <Header/>
        <Component />
    </div>
};

export default PublicRoute;
